import { withTypography } from 'components/ui';

export const StyledHeader = withTypography({
  variant: 'headerOne',
  textAlign: 'center',
});
